import React, { useState, useEffect } from "react";
import {
  Button,
  Col,
  Row,
  Container,
  Carousel,
  Form,
  Spinner,
} from "react-bootstrap";

import "./Login.css";
import "bootstrap/dist/css/bootstrap.min.css";
import logo from "../../logo.svg";
import { useHistory } from "react-router-dom";
// import "./jquery.wmuSlider.js"
// import loginBg from "../images/login-bg.png";
// import { Iconly } from "react-iconly";
import { useSelector, useDispatch } from "react-redux";
import { login } from "../../redux/features/authVerification/authThunk";
import { resetLoginCount } from "../../redux/features/authVerification/authSlice";

const Login = () => {
  let history = useHistory();
  const dispatch = useDispatch();
  const [values, setValues] = useState({
    email: "",
    exam: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues((values) => ({ ...values, [name]: value }));
  };

  const handleSubmit = (e) => {
    dispatch(resetLoginCount());
    e.preventDefault();
    //dispatching login action
    let adjustedValues = {
      email: values.email.toLowerCase().trim(),
      exam: values.exam.trim(),
    };
    dispatch(login(adjustedValues));
    // history.push("/");
  };

  const { userData, loading } = useSelector((state) => state.auth);

  useEffect(() => {
    if (userData?.email) {
      history.push("/");
    }
  }, [userData, history]);

  return (
    <Container fluid className="lg-box">
      <Row className="min-100vh">
        <Col xs={6} className="p-0 carousel-bg-img">
          <a href="https://proctorme.com/">
            <img
              className="m-4 pl-4"
              style={{ height: "2rem" }}
              src={logo}
              alt="logo"
            />
          </a>

          <Carousel fade className="carousel-bg-img">
            <Carousel.Item className="d-flex align-item-center pt-4 mt-4">
              <div className=" p-4 mt-4">
                <h3 className="carousel-Title text-center">INSTRUCTION</h3>
                <p className="carousel-text text-center">
                  please make sure you are in a very quiet environment for a
                  proper and flawless examination. follow every instructions as
                  they would guide you to a very smooth examination. Goodluck!.
                </p>
              </div>
            </Carousel.Item>
            <Carousel.Item className="d-flex align-item-center pt-4 mt-4">
              <div className=" p-4 mt-4">
                <h3 className="carousel-Title text-center">ABOUT US</h3>
                <p className="carousel-text text-center">
                  please make sure you are in a very quiet environment for a
                  proper and flawless examination. follow every instructions as
                  they would guide you to a very smooth examination. Goodluck!.
                </p>
              </div>
            </Carousel.Item>
            <Carousel.Item className="d-flex align-item-center pt-4 mt-4">
              <div className=" p-4 mt-4">
                <h3 className="carousel-Title text-center">FOLLOW US</h3>
                <p className="carousel-text text-center">
                  please make sure you are in a very quiet environment for a
                  proper and flawless examination. follow every instructions as
                  they would guide you to a very smooth examination. Goodluck!.
                </p>
              </div>
            </Carousel.Item>
          </Carousel>
        </Col>

        <Col xs={6} className="position-relative">
          <a
            href="https://proctorme.com/"
            className="back-btn text-info d-flex position-absolute"
          >
            <h6 className=" me-3">&lt;</h6>
            <h6>Back Home</h6>
          </a>
          <div className="login-container w-100">
            <div className="box">
              <h2 className="candidate-title">CANDIDATE</h2>
              <hr></hr>
            </div>

            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3 " controlId="formBasicEmail">
                <Form.Label>Email address</Form.Label>
                <div
                  className="wrap-input100 validate-input"
                  data-validate="Valid email is required: ex@abc.xyz"
                >
                  <input
                    className="input100"
                    type="email"
                    name="email"
                    value={values.email}
                    onChange={handleChange}
                    required
                    placeholder="enter email details"
                  />
                  <span className="focus-input100"></span>
                  <span className="symbol-input100">
                    <svg
                      width="18"
                      height="16"
                      viewBox="0 0 20 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M14.9395 0C16.2805 0 17.5705 0.53 18.5195 1.481C19.4695 2.43 20.0005 3.71 20.0005 5.05V12.95C20.0005 15.74 17.7305 18 14.9395 18H5.06049C2.26949 18 0.000488281 15.74 0.000488281 12.95V5.05C0.000488281 2.26 2.25949 0 5.06049 0H14.9395ZM16.5305 6.54L16.6105 6.46C16.8495 6.17 16.8495 5.75 16.5995 5.46C16.4605 5.311 16.2695 5.22 16.0705 5.2C15.8605 5.189 15.6605 5.26 15.5095 5.4L11.0005 9C10.4205 9.481 9.58949 9.481 9.00049 9L4.50049 5.4C4.18949 5.17 3.75949 5.2 3.50049 5.47C3.23049 5.74 3.20049 6.17 3.42949 6.47L3.56049 6.6L8.11049 10.15C8.67049 10.59 9.34949 10.83 10.0605 10.83C10.7695 10.83 11.4605 10.59 12.0195 10.15L16.5305 6.54Z"
                        fill="#200E32"
                      />
                    </svg>{" "}
                  </span>
                </div>
              </Form.Group>

              <Form.Group className="mb-3 " controlId="formBasicEmail">
                <Form.Label>Exam ID</Form.Label>
                <div
                  className="wrap-input100 validate-input"
                  data-validate="Valid email is required: ex@abc.xyz"
                >
                  <input
                    className="input100"
                    type="text"
                    name="exam"
                    value={values.exam}
                    onChange={handleChange}
                    required
                    placeholder="enter exam id"
                  />
                  <span className="focus-input100"></span>
                  <span className="symbol-input100">
                    <svg
                      width="16"
                      height="18"
                      viewBox="0 0 18 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M14.5227 5.39601V6.92935C16.2451 7.46696 17.5 9.02614 17.5 10.8884V15.8253C17.5 18.1308 15.5886 20 13.2322 20H4.7688C2.41136 20 0.5 18.1308 0.5 15.8253V10.8884C0.5 9.02614 1.75595 7.46696 3.47729 6.92935V5.39601C3.48745 2.41479 5.95667 0 8.98476 0C12.0535 0 14.5227 2.41479 14.5227 5.39601ZM9.00508 1.73904C11.0678 1.73904 12.7445 3.37871 12.7445 5.39601V6.7137H5.25553V5.37613C5.26569 3.36878 6.94232 1.73904 9.00508 1.73904ZM9.88912 14.4549C9.88912 14.9419 9.49283 15.3294 8.99492 15.3294C8.50717 15.3294 8.11088 14.9419 8.11088 14.4549V12.2488C8.11088 11.7718 8.50717 11.3843 8.99492 11.3843C9.49283 11.3843 9.88912 11.7718 9.88912 12.2488V14.4549Z"
                        fill="#200E32"
                      />
                    </svg>
                  </span>
                </div>
              </Form.Group>
              <Button
                variant="primary"
                style={{ paddingTop: "0.8rem", paddingBottom: "0.8rem" }}
                className="w-100 rounded"
                type="submit"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />{" "}
                    Loading...
                  </>
                ) : (
                  "Take Exam"
                )}{" "}
              </Button>
              <div className="d-flex py-4">
                <p className="text-info me-2"> Can't login?</p>
                <a href="mailto:support@proctorme.com" className="support-link">
                  contact support{" "}
                </a>
              </div>
            </Form>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Login;
